import { Injectable } from '@angular/core';
import { share, shareReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  bulans = [
    { id: 1, name: 'Januari', shortcode: 'jan' },
    { id: 2, name: 'Februari', shortcode: 'feb' },
    { id: 3, name: 'Maret', shortcode: 'mar' },
    { id: 4, name: 'April', shortcode: 'apr' },
    { id: 5, name: 'Mei', shortcode: 'mei' },
    { id: 6, name: 'Juni', shortcode: 'jun' },
    { id: 7, name: 'Juli', shortcode: 'jul' },
    { id: 8, name: 'Agustus', shortcode: 'agt' },
    { id: 9, name: 'September', shortcode: 'sep' },
    { id: 10, name: 'Oktober', shortcode: 'okt' },
    { id: 11, name: 'November', shortcode: 'nov' },
    { id: 12, name: 'Desember', shortcode: 'des' },
  ];

  public collapsed: boolean = true;

  toastr_config = {
    timeOut: 3000,
    tapToDismiss: true,
    closeButton: true,
  };

  constructor(
    private http: HttpClient,
    private envService: EnvService,
    private toastr: ToastrService
  ) {}

  getErrorMessage(errors): string {
    var str = '';
    errors.forEach((item, idx) => {
      str += item;
      if (idx != errors.length - 1) {
        str += '\n';
      }
    });
    return str;
  }

  apiGet(endpoint, params) {
    let getReq = this.http
      .get<any>(this.envService.env.apiUrl + endpoint, { params })
      .pipe(shareReplay());
    return getReq;
  }

  getCurrentApiUrl(): string {
    return this.envService.env?.apiUrl || 'ENV_NULL';
  }

  apiPost(endpoint, body) {
    let postReq = this.http
      .post<any>(this.envService.env.apiUrl + endpoint, body)
      .pipe(shareReplay());
    return postReq;
  }

  async showToast(position, status, message) {
    if (status === 'success') {
      this.showToastSuccess(message);
    } else if (status === 'danger') {
      this.showToastError(message);
    } else if (status === 'info') {
      this.showToastInfo(message);
    } else {
      this.showToastWarning(message);
    }
  }

  showToastSuccess(message, title = 'Success') {
    this.toastr.success(message, title, this.toastr_config);
  }

  showToastError(message, title = 'Error Occurred') {
    this.toastr.error(message, title, this.toastr_config);
  }

  showToastInfo(message, title = 'Info') {
    this.toastr.info(message, title, this.toastr_config);
  }

  showToastWarning(message, title = 'Warning') {
    this.toastr.warning(message, title, this.toastr_config);
  }

  collapsible(el) {
    let coll = el.querySelector('.collapsible');
    let up = el.querySelector('.collapse-icon-up');
    let down = el.querySelector('.collapse-icon-down');
    up.classList.toggle('show');
    down.classList.toggle('show');
    coll.classList.toggle('active');
    el.classList.toggle('hide-child');
  }

  generateRandomNumber(length) {
    let result = '';
    for (let i = 0; i < length; i++) {
      result += (Math.floor(Math.random() * 9) + 1).toString();
    }

    return result;
  }
}
